import Vue from 'vue';

import LoadingLarge from '@/Common/LoadingElements/LoadingLarge.vue';
Vue.component('loader-large', LoadingLarge);

import LoadingSmall from '@/Common/LoadingElements/LoadingSmall.vue';
Vue.component('loader-small', LoadingSmall);

import SavingLarge from '@/Common/LoadingElements/SavingLarge.vue';
Vue.component('saver-large', SavingLarge);

import MarkdownContent from '@/Common/MarkdownContent.vue';
Vue.component('markdown-content', MarkdownContent);

import FakeYoutube from '@/Common/FakeYoutube.vue';
Vue.component('fake-youtube', FakeYoutube);

import Modal from '@/Common/Modal.vue';
Vue.component('modal', Modal);


// WEBPACK FOOTER //
// ./src/vueComponents.js